import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_NOBEL_GREY,
	COLOR_WHITE,
	COLOR_BLACK,
	COLOR_FLAT_RED,
	FONT_WT_HEAVY,
	COLOR_DARK_RED,
	COLOR_LINK_GREEN,
	COLOR_LINK_HOVER_BLUE,
	COLOR_BUTTON_HOVER,
	COLOR_BUTTON_BORDER_GREY,
	FONT_WT_REGULAR,
	COLOR_INPUT_SHADOW,
} from "@website-builder/utilities-index";

export const RequestSyllabusModalWrapper = styled.div`
	.modalBody {
		width: 600px;
		.modalContent {
			margin-top: 40px;
			margin-bottom: 50px;
			padding: 0 35px;
			.imageWrapper {
				min-height: 60px;
				margin-bottom: 20px;
				height: 60px;
				font-size: 0;
				img {
					height: 60px;
				}
			}
			h3 {
				margin-top: 10px;
				margin-right: 60px;
				font-size: 28px;
				font-weight: ${FONT_WT_MEDIUM};
				text-align: left;
				color: ${COLOR_TEXT_PRIMARY_B2C};
			}
			.request-syllabus-modal-form {
				justify-content: space-between;
			}
		}
		.hs-field-desc {
			display: none !important;
		}
		.hs-form-field {
			margin-bottom: 13px;
			color: ${COLOR_NOBEL_GREY};
		}
		.hs-form-required {
			display: none;
		}
		.hs_error_rollup {
			display: none;
		}
		.hs-error-msgs {
			color: ${COLOR_DARK_RED};
			list-style: none;
			margin: 0px;
			padding: 0px 2px;
			font-size: 11px;
			line-height: 11px;
		}
		.legal-consent-container {
			color: ${COLOR_NOBEL_GREY};
			font-size: 14px;
			line-height: 1.42857143;
			a {
				color: ${COLOR_LINK_GREEN};
				text-decoration: none;
			}
			a:hover {
				text-decoration: underline;
				color: ${COLOR_LINK_HOVER_BLUE};
			}
		}
		.hs-button {
			width: 100%;
			color: ${COLOR_WHITE};
			font-weight: ${FONT_WT_HEAVY};
			font-size: 16px;
			height: 47px;
			background-color: ${COLOR_FLAT_RED};
			border: 1px solid ${COLOR_FLAT_RED};
			border-radius: 4px;
			:hover {
				background-color: ${COLOR_BUTTON_HOVER};
			}
			:focus {
				border: none;
				box-shadow: none;
			}
		}
		.hs-input {
			width: 100%;
			background-color: ${COLOR_WHITE};
			height: 47px;
			box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.05);
			border-color: ${COLOR_BUTTON_BORDER_GREY};
			font-size: 16px;
			color: ${COLOR_NOBEL_GREY};
			padding-left: 20px;
			padding-right: 20px;
			border: 1px solid ${COLOR_BUTTON_BORDER_GREY};
			border-radius: 4px;
			display: inline-block;
			width: 100%;
			position: relative;
			vertical-align: top;
			::placeholder {
				color: ${COLOR_NOBEL_GREY};
				opacity: 1;
			}
		}
		.error {
			border: 1px solid ${COLOR_DARK_RED};
		}
		.hs-richtext > h2 {
			font-size: 18px;
			font-weight: ${FONT_WT_HEAVY};
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		input:focus,
		textarea:focus,
		select:focus {
			outline: none;
			box-shadow: 0 0 5px ${COLOR_INPUT_SHADOW};
			border: 1px solid ${COLOR_INPUT_SHADOW};
		}
		.submitted-message {
			min-height: 400px;
			p {
				position: absolute;
				top: 40%;
				margin-right: 20px;
				text-align: center;
				font-weight: ${FONT_WT_REGULAR};
				color: ${COLOR_BLACK};
			}
		}
	}
`;
